export class TokenManager {
    constructor(props) {
        this.key = 'inplayer_key';
    }

    get() {
        return localStorage.getItem(this.key);
    }

    set(token) {
        localStorage.setItem(this.key, token);
    }

    clear() {
        localStorage.removeItem(this.key);
    }
}

export default new TokenManager();



// WEBPACK FOOTER //
// ./src/utils/token.js